
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44.1 44.1"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st1",attrs:{"fill":"#FFF","d":"M22 .5C34.2.5 43.4 10 43.4 22.1S34.2 44 22 44 0 34.2 0 22 9.9.5 22 .5z"}}),_c('path',{staticClass:"st2",attrs:{"fill":"#23A1C0","d":"M22.1.1C10 .1.1 10 .1 22.1s9.9 22 22 22 22-9.9 22-22-9.9-22-22-22zm12.2 29c0 .6-.2 1.2-.6 1.6-.5.5-1 .6-1.6.6h-20c-.6 0-1.2-.2-1.6-.6-.5-.5-.6-1-.6-1.6v-9.8c0-.1 0-.2.1-.2h.4c1.1.9 7.8 5.9 7.8 5.9.7.6 1.3 1 1.8 1.2.7.4 1.5.6 2.1.6s1.3-.2 2.1-.6c.5-.2 1.1-.6 1.8-1.2l.5-.4c3.8-2.7 6.2-4.5 7.3-5.4.1-.1.2-.1.4 0s.1.1.1.2v9.7zm-.4-12l-.2.2c-1.3 1.1-8.6 6.4-8.6 6.4-.6.5-1.1.9-1.5 1.1-.6.4-1.1.6-1.6.6-.4 0-1-.2-1.6-.6-.4-.2-.9-.5-1.5-1.1 0 0-7-5.4-8.3-6.4l-.4-.2c-.2-.2-.5-.5-.5-.9v-.9c0-.6.2-1.2.6-1.6.4-.4 1-.6 1.6-.6h19.9c.6 0 1.2.2 1.6.6.5.5.6 1 .6 1.6v.9c.1.1 0 .8-.1.9z"}})])
          )
        }
      }
    